/** @format */

import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { ACTIONS } from "../reducer/authReducer";

const Toast = ({ ...rest }) => {
  const { authState } = useAuth();

  const { toast, toastText, toastBg } = authState;

  return (
    <>
      {toast && (
        <div style={{ backgroundColor: toastBg }} className="toast" {...rest}>
          {toastText}
        </div>
      )}
    </>
  );
};

export default Toast;
